class CapacityReportController {
    constructor($browser, $window, $location, toastr, UserDetailsApi, SettingsService, ReportServiceApi, CapacityServiceApi) {
        this.init = () => {
            this.state = {
                capacityReport: this.resolve.capacityReport,
                showTesters: true,
                userDetails: undefined,
                activeTesters: [],
                UsersCapacitySims: [],
                selectedTester: { Id: 0, Name: 'Unknown' },
                selectedSim: { Id: 0, Name: 'Unknown' },
                selectedReport: { Id: 0, Name: 'Unknown' },
                selectedUserActiveSim: { Id: 0, Name: 'Unknown' },
                runReport: false,
                showLoadingSpinner: true
            };
            this.data = {
                sims: [],
                capacityReports: []
            };
            this.UserDetailsApi.get().then((response) => {
                this.state.userDetails = response.data; // setup our user details
                this.state.showTesters =
                    this.state.userDetails.IsSupport ||
                        this.state.userDetails.IsAdmin ||
                        this.state.userDetails.IsProjectTester;
                this.CapacityServiceApi.getAvailableCapacityReportsForUser().then((simResponse) => {
                    let capacityReportsResponse = simResponse.data;
                    this.state.UsersCapacitySims = capacityReportsResponse.UserCapacitySims;
                    this.data.capacityReports = capacityReportsResponse.CapacityReports;
                    if (this.state.UsersCapacitySims.length > 0) {
                        let idx = 0;
                        this.state.activeTesters = [];
                        for (idx = 0; idx < this.state.UsersCapacitySims.length; idx++) {
                            // Only show the user if they've got any sims - no point otherwise
                            if (this.state.UsersCapacitySims[idx].CapacitySims.length > 0) {
                                this.state.activeTesters.push(this.state.UsersCapacitySims[idx].User);
                            }
                        }
                        this.state.selectedTester = this.state.activeTesters[0];
                        this.selectTester(this.state.selectedTester);
                    }
                    this.state.showLoadingSpinner = false;
                });
            });
        };
        this.selectTester = (tester) => {
            this.state.runReport = false;
            // Find user in the list of UsersCapacitySims
            let idx = 0;
            let testerIdx = -1;
            for (idx = 0; idx < this.state.UsersCapacitySims.length; idx++) {
                if (this.state.UsersCapacitySims[idx].User.Id === tester.Id) {
                    testerIdx = idx;
                    break;
                }
            }
            // Clear list of available capacity simulators, then repopulate it
            this.data.sims = [];
            if (testerIdx > -1) {
                this.state.selectedTester = tester;
                for (idx = 0; idx < this.state.UsersCapacitySims[testerIdx].CapacitySims.length; idx++) {
                    this.data.sims.push(this.state.UsersCapacitySims[testerIdx].CapacitySims[idx]);
                }
                if (this.data.sims.length > 0) {
                    this.state.selectedUserActiveSim = this.state.UsersCapacitySims[testerIdx].ActiveCapacitySim;
                    this.state.selectedSim = this.state.selectedUserActiveSim !== null ? this.state.selectedUserActiveSim : this.data.sims[0];
                    this.selectSim(this.state.selectedSim);
                }
            }
        };
        this.selectSim = (sim) => {
            if (this.data.capacityReports.length > 0) {
                this.state.selectedReport = this.data.capacityReports[0];
                this.selectReport(this.state.selectedReport);
            }
        };
        this.selectReport = (capacityReport) => {
            let enableRunReport = false;
            let idx = 0;
            // enable the export report button if the report is valid
            for (idx = 0; idx < this.data.capacityReports.length; idx++) {
                if (this.data.capacityReports[idx].Id === capacityReport.Id) {
                    enableRunReport = true;
                    this.state.selectedReport = capacityReport;
                    break;
                }
            }
            this.state.runReport = enableRunReport;
        };
        this.exportZip = () => {
            // Request the ZIP for the currently selected combination of user, sim and report
            // is created and downloaded.
            let url = `api/Capacity/Reports/${this.state.selectedTester.Id}/${this.state.selectedSim.Id}/${this.state.selectedReport.Id}`;
            this.window.open(url, '_blank' // <- This is what makes it open in a new window, Workaround for IE.
            );
            this.dismiss();
        };
        this.groupSimulators = (sim) => {
            if (this.state.selectedUserActiveSim !== null && sim.Id === this.state.selectedUserActiveSim.Id) {
                return 'Active';
            }
            else {
                return 'Archived';
            }
        };
        this.orderSimulators = (groups) => {
            // Make sure Active is always at the top if it's present
            return groups.sort((a, b) => {
                return a.name === 'Active' ? -1 : 1;
            });
        };
        this.$onInit = () => {
            this.init();
        };
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.ReportServiceApi = ReportServiceApi;
        this.CapacityServiceApi = CapacityServiceApi;
        this.SettingsService = SettingsService;
        this.UserDetailsApi = UserDetailsApi;
        this.toastr = toastr;
    }
}
// Component Declaration
angular.module('app').component('capacityReport', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'Scripts/App/partials/Reports/Capacity-Report.tpl.html',
    controllerAs: 'vm',
    controller: CapacityReportController
});
